import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Square } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Sep 9 2026, user's explicit ask: a matching "ERP Synced"/"ERP
// Disconnected" badge alongside the existing SAP one, on every page - is
// the ERP (MS SQL) portal server reachable right now, NOT a per-STO
// sync status. Same visual style/60s poll pattern as SapConnectionStatus.
// Oct 13 2026, user's explicit ask ("eliminate this pill design...
// ERP-level professional"): rectangular "System Monitor" module (white
// chip, square LED, semantic text color) instead of a solid-color pill.
export const ErpConnectionStatus = () => {
  const [connection, setConnection] = useState({ connected: null, message: "Checking connection..." });

  const checkConnection = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/erp/connection-status`);
      setConnection(data);
    } catch {
      setConnection({ connected: false, message: "Unable to reach backend" });
    }
  }, []);

  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, 60000);
    return () => clearInterval(interval);
  }, [checkConnection]);

  const statusColor = connection.connected === null ? "#B45309" : connection.connected ? "#15803D" : "#B91C1C";

  return (
    <div
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-[3px] border border-[#E2E8F0] bg-white shrink-0 text-[11px] font-bold tracking-wide shadow-sm"
      data-testid="erp-connection-status-indicator"
      title={connection.message}
    >
      <Square size={8} weight="fill" style={{ color: statusColor }} className={connection.connected === null || connection.connected ? "animate-pulse" : ""} />
      <span className="font-sans whitespace-nowrap hidden md:inline uppercase" style={{ color: statusColor }}>
        {connection.connected === null
          ? "Checking ERP..."
          : connection.connected
          ? "ERP Synced"
          : "ERP Disconnected"}
      </span>
    </div>
  );
};
